import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

/**
 * Serviço para gerenciar serviços oferecidos
 */
export const servicesService = {
  /**
   * Busca os serviços disponíveis
   */
  async getServices() {
    try {
      const response = await api.get(ENDPOINTS.SERVICES);
      
      if (response.data?.error) {
        throw new Error('Erro ao buscar serviços');
      }

      return {
        success: true,
        services: response.data?.response || [],
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.msg || error.response?.data?.message || error.message || 'Erro ao buscar serviços',
      };
    }
  },

  /**
   * Atualiza os serviços da entidade
   */
  async updateEntityServices(entityId, services) {
    try {
      const formattedServices = services.map(service => ({
        entityId,
        serviceId: service.serviceId,
        description: service.description || null
      }));

      const response = await api.post(ENDPOINTS.ENTITIES_SERVICES, {
        entityId,
        services: formattedServices
      });
      
      if (response.data?.error) {
        throw new Error('Erro ao atualizar serviços');
      }

      return {
        success: true,
        response: response.data?.response
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.msg || error.response?.data?.message || error.message || 'Erro ao atualizar serviços',
      };
    }
  }
};
